<template>
  <div class="expanded-fieldset">
    <div class="trail">
      <div class="title">
        {{title}}
      </div>
    </div>
    <div class="fields">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  // as opposed to collapsable
  name: 'ExpandedFieldset',
  props: ['title'],
  data() {
    return {
      active: false,
    };
  },
};
</script>
